<template>
  <div>
    <div v-if="limsds_userDetails.userEmail != null && limsds_userDetails.userEmail != ''">
      <v-form v-show="HideAppEle" ref="form" v-model="valid" lazy-validation>
        <v-row dense>
          <v-col class="Instructions" sm="11">
            Enter criteria to search for Samples (fields left blank will not
            affect search)
          </v-col>
          <v-col align="Right" sm="1">
            <v-menu open-on-hover top offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-icon color="orange" small v-bind="attrs" v-on="on"
                  >mdi-help</v-icon
                >
              </template>
              <v-list>
                <v-list-item>
                  <a
                    :href="HelpSearchBySample"
                    title="About This Page"
                    target="limsds_help"
                    >About This Page</a
                  ></v-list-item
                >
                <v-list-item
                  ><a
                    :href="NewsLetter"
                    title="Newsletter Index"
                    target="limsds_help"
                    >Newsletter Index</a
                  ></v-list-item
                >
              </v-list>
            </v-menu>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col sm="11">
            <v-checkbox
              dense
              v-model="defaultValues.onlySamplesPreviousYear"
              hide-details
              :label="`Only include unit, area and product selections for samples that have been collected in the previous year`"
            ></v-checkbox>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col sm="3">
            <v-select 
              solo
              hide-details
              dense
              label="Select Site"
              v-model="list.site1"
              @input="FillUnitDropDown"
              :items="defaultValues.SiteList"
              item-text="site"
              item-value="site"
            ></v-select>
          </v-col>
          </v-row>
        <v-row dense>
          <v-col sm="3">
            <v-select
              label="Select Unit"
              v-model="defaultValues.SelectedUnit"
              @input="FillAreaDropDown"
              :items="this.defaultValues.UnitList"
              solo
              hide-details
              dense
              item-text="UnitName"
              item-value="UnitValue"
            ></v-select>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col sm="3">
            <v-select
              solo
              hide-details
              dense
              label="Select Area"
              v-model="defaultValues.SelectedArea"
              @input="FillSamplePointDropDown"
              :items="defaultValues.AreaList"
              item-text="AreaName"
              item-value="AreaID"
            ></v-select>
          </v-col>
          </v-row>
        <v-row dense>
          <v-col sm="3">
            <v-select
              solo
              hide-details
              dense
              label="Select Group"
              v-model="defaultValues.SelectedGroup"
              :items="defaultValues.LabAreaList"
              item-text="LabAreaName"
              item-value="LabAreaID"
            ></v-select>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col sm="1">
            <v-select
              solo
              hide-details
              dense
              label="Sample Point"
              v-model="defaultValues.DDSamplePoint"
              :items="defaultValues.itemsCommonDD"
              item-text="name"
              item-value="id"
            ></v-select>
          </v-col>
          <v-col sm="4">
            <v-autocomplete
              v-model="defaultValues.SamplePoint"
              :items="defaultValues.SamplePointList"
              item-text="point"
              item-value="d_key"
              dense
              solo
              hide-details
              filled
              label="Sample Point"
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col sm="1">
            <v-select
              label="Product"
              v-model="defaultValues.DDProduct"
              solo
              hide-details
              dense
              :items="defaultValues.itemsCommonDD"
              item-text="name"
              item-value="id"
            ></v-select>
          </v-col>
          <v-col sm="4">
            <v-autocomplete
              v-model="defaultValues.Product"
              :items="defaultValues.ProductList"
              item-text="ProductName"
              item-value="ProductID"
              dense
              solo
              hide-details
              filled
              label="Product"
            ></v-autocomplete> </v-col
          >
        </v-row>
        <v-row dense>
          <v-col sm="1">
            <v-select
              label="Sample Description"
              v-model="defaultValues.DDSampleDesc"
              dense
              solo
              hide-details
              :items="defaultValues.itemsCommonDD"
              item-text="name"
              item-value="id"
            ></v-select>
          </v-col>
          <v-col sm="4">
            <v-text-field
              v-model="defaultValues.SampleDesc"
              dense
              solo
              hide-details
              label="Sample Description"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col sm="1">
            <v-select
              label="Test"
              v-model="defaultValues.DDTest"
              solo
              hide-details
              dense
              :items="defaultValues.itemsCommonDD"
              item-text="name"
              item-value="id"
            ></v-select>
          </v-col>
          <v-col sm="4">
            <v-text-field
              v-model="defaultValues.Test"
              dense
              solo
              hide-details
              label="Test"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col sm="1">
            <v-select
              label="Batch ID"
              v-model="defaultValues.DDBatchID"
              dense
              solo
              hide-details
              :items="defaultValues.itemsCommonDD"
              item-text="name"
              item-value="id"
            ></v-select>
          </v-col>
          <v-col sm="4">
            <v-text-field
              dense
              solo
              hide-details
              v-model="defaultValues.BatchID"
              label="Batch ID"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col sm="1">
            <v-select
              label="Material Number"
              v-model="defaultValues.DDMaterialNum"
              dense
              solo
              hide-details
              :items="defaultValues.itemsCommonDD"
              item-text="name"
              item-value="id"
            ></v-select>
          </v-col>
          <v-col sm="4">
            <v-text-field
              dense
              solo
              hide-details
              v-model="defaultValues.MaterialNum"
              label="Material Number"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col sm="1">
            <v-select
              label="Material Description"
              v-model="defaultValues.DDMaterialDesc"
              dense
              solo
              hide-details
              :items="defaultValues.itemsCommonDD"
              item-text="name"
              item-value="id"
            ></v-select>
          </v-col>
          <v-col sm="4">
            <v-text-field
              dense
              solo
              hide-details
              v-model="defaultValues.MaterialDesc"
              label="Material Description"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col sm="1">
            <v-select
              label="Sample Comment"
              v-model="defaultValues.DDComment"
              dense
              solo
              hide-details
              :items="defaultValues.itemsCommonDD"
              item-text="name"
              item-value="id"
            ></v-select>
          </v-col>
          <v-col sm="4">
            <v-text-field
              dense
              solo
              hide-details
              v-model="defaultValues.Comment"
              label="Sample comment"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col sm="3">
            <v-select
              dense
              solo
              hide-details
              v-model="defaultValues.SelectedLimitComp"
              label="Has Off Limit Components"
              :items="defaultValues.itemsLimitComp"
              item-text="name"
              item-value="id"
            ></v-select>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col class="Instructions" sm="11">
            Relative dates are accepted (0 is today, -7 is seven days in the
            past)
          </v-col>
        </v-row>
        <v-row dense>
          <v-col>
            <start-end-date-control
              :startDate.sync="dateValues.startDate"
              :endDate.sync="dateValues.endDate"
              :numIncSD.sync="dateValues.numIncSD"
              :numIncED.sync="dateValues.numIncED"
            ></start-end-date-control>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col sm="2">
            <v-btn
              :disabled="!valid"
              rounded
              dense
              solo
              hide-details
              color="primary"
              dark
              @click="FetchSampleListResult()"
              >Get Results
            </v-btn>
          </v-col>
          <v-col sm="2">
            <v-btn
              rounded
              solo
              hide-details
              dense
              color="primary"
              dark
              @click="ResetFilter()"
              >Reset Result Fields
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col></v-col>
        </v-row>
      </v-form>
      <SearchBySampleResult
        v-on:ShowFilterHideResult="ShowFilterHideResult($event)"
        v-if="Show"
        :onlySamplesPreviousYear="this.defaultValues.onlySamplesPreviousYear"
        :SelectedSite="this.list.site1"
        :SelectedUnit="this.defaultValues.SelectedUnit"
        :SelectedArea="this.defaultValues.SelectedArea"
        :SelectedGroup="this.defaultValues.SelectedGroup"
        :SamplePointAPI="this.defaultValues.SamplePointAPI"
        :ProductAPI="this.defaultValues.ProductAPI"
        :SampleDescAPI="this.defaultValues.SampleDescAPI"
        :TestAPI="this.defaultValues.TestAPI"
        :BatchIDAPI="this.defaultValues.BatchIDAPI"
        :MaterialNumAPI="this.defaultValues.MaterialNumAPI"
        :MaterialDescAPI="this.defaultValues.MaterialDescAPI"
        :CommentAPI="this.defaultValues.CommentAPI"
        :SelectedLimitComp="this.defaultValues.SelectedLimitComp"
        :StartDate="this.dateValues.startDate"
        :EndDate="this.dateValues.endDate"
        :userId="this.userId"
        :lims_internal="this.defaultValues.lims_internal"
      />
    </div>
    <div v-if="limsds_userDetails.userEmail == null">
      <h3>INVALID USER !!!</h3>
      <h4>Current user is not exist in system database !!!</h4>
    </div>
  </div>
</template>
<script>
import SearchBySampleResult from "./SearchBySampleResult.vue";
import axios from "axios";
import uiView from "@/_mixins/ui-view-mixin";
import appMixin from "../mixins/app-mixin";
import startEndDateControl from "../components/startEndDateControl";
export default {
  name: "SearchBySample",
  mixins: [uiView, appMixin],
  components: {
    SearchBySampleResult,
    startEndDateControl,
  },

  created() {
    this.NewsLetter = this.settings.NewsLetter;
    this.HelpSearchBySample = this.settings.HelpSearchBySample;
    if (this.limsds_userDetails.userEmail != null) {
      this.list = this.limsds_userPreference;
      this.PrefSite = this.list.site1;
      this.DateFormat = this.list.Dateformat;
      this.FillSite();
      this.FillUnitDropDown(this.list.site1);
      this.FillSamplePointDropDown(
        this.list.site1,
        null,
        null,
        this.limsds_userDetails.userEmail
      );
    }
  },
  mounted() {},
  data() {
    return {
      valid: true,
      Show: false,
      PrefSite: null,
      DateFormat: null,
      list: {},
      HideAppEle: true,
      SampleListResult: {},
      dateValues: {
        numIncSD: "-7",
        numIncED: "0",
        startDate: null,
        endDate: null,
      },
      defaultValues: {
        SiteList: undefined,
        UnitList: undefined,
        AreaList: undefined,
        LabAreaList: undefined,
        SamplePointList: undefined,
        ProductList: undefined,
        onlySamplesPreviousYear: "1",
        lims_internal: "0",
        SelectedSite: null,
        SelectedUnit: null,
        SelectedArea: null,
        SelectedGroup: null,
        DDSamplePoint: 1,
        SamplePoint: "",
        SamplePointAPI: "%",
        DDProduct: 1,
        Product: "",
        ProductAPI: "%",
        DDSampleDesc: 1,
        SampleDesc: "",
        SampleDescAPI: "%",

        DDTest: 1,
        Test: "",
        TestAPI: "%",
        DDBatchID: 1,
        BatchID: "",
        BatchIDAPI: "%",
        DDMaterialNum: 1,
        MaterialNum: "",
        MaterialNumAPI: "%",
        DDMaterialDesc: 1,
        MaterialDesc: "",
        MaterialDescAPI: "%",
        DDComment: 1,
        Comment: "",
        CommentAPI: "%",
        SelectedLimitComp: "-1",
        itemsLimitComp: [
          { name: "No Preference", id: "-1" },
          { name: "Yes", id: "1" },
          { name: "No", id: "0" },
        ],
        itemsCommonDD: [
          { name: "Contains", id: 1 },
          { name: "Start With", id: 2 },
          { name: "Exact", id: 3 },
        ],
      },
    };
  },
  methods: {
    FillSite() {
      let that = this;
      const SiteLink = that.settings.WASite + "UserID=" + that.limsds_userDetails.userEmail;
      axios.get(SiteLink).then((response) => {
        this.defaultValues.SiteList = response.data.enumSiteLists;
      });
    },
    ShowFilterHideResult() {
      this.HideAppEle = true;
      this.Show = false;
    },
    ResetFilter() {
      this.list.site1 = this.PrefSite;
      this.defaultValues.SelectedUnit = null;
      this.defaultValues.onlySamplesPreviousYear = "1";
      this.defaultValues.lims_internal = "0";
      this.dateValues.startDate = null;
      this.dateValues.endDate = null;
      this.defaultValues.SelectedArea = null;
      this.defaultValues.SelectedGroup = null;
      this.defaultValues.DDSamplePoint = 1;
      this.defaultValues.SamplePoint = "";
      this.defaultValues.SamplePointAPI = "%";
      this.defaultValues.DDProduct = 1;
      this.defaultValues.Product = "";
      this.defaultValues.ProductAPI = "%";
      this.defaultValues.DDSampleDesc = 1;
      this.defaultValues.SampleDesc = "";
      this.defaultValues.SampleDescAPI = "%";

      this.defaultValues.DDTest = 1;
      this.defaultValues.Test = "";
      this.defaultValues.TestAPI = "%";
      this.defaultValues.DDBatchID = 1;
      this.defaultValues.BatchID = "";
      this.defaultValues.BatchIDAPI = "%";
      this.defaultValues.DDMaterialNum = 1;
      this.defaultValues.MaterialNum = "";
      this.defaultValues.MaterialNumAPI = "%";
      this.defaultValues.DDMaterialDesc = 1;
      this.defaultValues.MaterialDesc = "";
      this.defaultValues.MaterialDescAPI = "%";
      this.defaultValues.DDComment = 1;
      this.defaultValues.Comment = "";
      this.defaultValues.CommentAPI = "%";
      this.defaultValues.SelectedLimitComp = "-1";
    },
    FetchSampleListResult() {
      if (this.defaultValues.onlySamplesPreviousYear == false) {
        this.defaultValues.onlySamplesPreviousYear = "0";
      } else {
        this.defaultValues.onlySamplesPreviousYear = "1";
      }

      if (this.defaultValues.SelectedUnit == null) {
        this.defaultValues.SelectedUnit = "";
      }
      if (this.defaultValues.SelectedArea == null) {
        this.defaultValues.SelectedArea = "";
      }
      if (this.defaultValues.SelectedGroup == null) {
        this.defaultValues.SelectedGroup = "";
      }
      if (this.defaultValues.SelectedLimitComp == null) {
        this.defaultValues.SelectedLimitComp = "-1";
      }

      if (
        this.defaultValues.DDSamplePoint == 1 &&
        this.defaultValues.SamplePoint != ""
      ) {
        this.defaultValues.SamplePointAPI =
          "%" + this.defaultValues.SamplePoint + "%";
      } else if (
        this.defaultValues.DDSamplePoint == 2 &&
        this.defaultValues.SamplePoint != ""
      ) {
        this.defaultValues.SamplePointAPI =
          "%" + this.defaultValues.SamplePoint;
      } else if (
        this.defaultValues.DDSamplePoint == 3 &&
        this.defaultValues.SamplePoint != ""
      ) {
        this.defaultValues.SamplePointAPI = this.defaultValues.SamplePoint;
      } else {
        this.defaultValues.SamplePointAPI = "%";
      }

      if (
        this.defaultValues.DDProduct == 1 &&
        this.defaultValues.Product != ""
      ) {
        this.defaultValues.ProductAPI = "%" + this.defaultValues.Product + "%";
      } else if (
        this.defaultValues.DDProduct == 2 &&
        this.defaultValues.Product != ""
      ) {
        this.defaultValues.ProductAPI = "%" + this.defaultValues.Product;
      } else if (
        this.defaultValues.DDProduct == 3 &&
        this.defaultValues.Product != ""
      ) {
        this.defaultValues.ProductAPI = this.defaultValues.Product;
      } else {
        this.defaultValues.ProductAPI = "%";
      }

      if (
        this.defaultValues.DDSampleDesc == 1 &&
        this.defaultValues.SampleDesc != ""
      ) {
        this.defaultValues.SampleDescAPI =
          "%" + this.defaultValues.SampleDesc + "%";
      } else if (
        this.defaultValues.DDSampleDesc == 2 &&
        this.defaultValues.SampleDesc != ""
      ) {
        this.defaultValues.SampleDescAPI = "%" + this.defaultValues.SampleDesc;
      } else if (
        this.defaultValues.DDSampleDesc == 3 &&
        this.defaultValues.SampleDesc != ""
      ) {
        this.defaultValues.SampleDescAPI = this.defaultValues.SampleDesc;
      } else {
        this.defaultValues.SampleDescAPI = "%";
      }
      if (this.defaultValues.DDTest == 1 && this.defaultValues.Test != "") {
        this.defaultValues.TestAPI = "%" + this.defaultValues.Test + "%";
      } else if (
        this.defaultValues.DDTest == 2 &&
        this.defaultValues.Test != ""
      ) {
        this.defaultValues.TestAPI = "%" + this.defaultValues.Test;
      } else if (
        this.defaultValues.DDTest == 3 &&
        this.defaultValues.Test != ""
      ) {
        this.defaultValues.TestAPI = this.defaultValues.Test;
      } else {
        this.defaultValues.TestAPI = "%";
      }

      if (
        this.defaultValues.DDBatchID == 1 &&
        this.defaultValues.BatchID != ""
      ) {
        this.defaultValues.BatchIDAPI = "%" + this.defaultValues.BatchID + "%";
      } else if (
        this.defaultValues.DDBatchID == 2 &&
        this.defaultValues.BatchID != ""
      ) {
        this.defaultValues.BatchIDAPI = "%" + this.defaultValues.BatchID;
      } else if (
        this.defaultValues.DDBatchID == 3 &&
        this.defaultValues.BatchID != ""
      ) {
        this.defaultValues.BatchIDAPI = this.defaultValues.BatchID;
      } else {
        this.defaultValues.BatchIDAPI = "%";
      }

      if (
        this.defaultValues.DDMaterialNum == 1 &&
        this.defaultValues.MaterialNum != ""
      ) {
        this.defaultValues.MaterialNumAPI =
          "%" + this.defaultValues.MaterialNum + "%";
      } else if (
        this.defaultValues.DDMaterialNum == 2 &&
        this.defaultValues.MaterialNum != ""
      ) {
        this.defaultValues.MaterialNumAPI =
          "%" + this.defaultValues.MaterialNum;
      } else if (
        this.defaultValues.DDMaterialNum == 3 &&
        this.defaultValues.MaterialNum != ""
      ) {
        this.defaultValues.MaterialNumAPI = this.defaultValues.MaterialNum;
      } else {
        this.defaultValues.MaterialNumAPI = "%";
      }

      if (
        this.defaultValues.DDMaterialDesc == 1 &&
        this.defaultValues.MaterialDesc != ""
      ) {
        this.defaultValues.MaterialDescAPI =
          "%" + this.defaultValues.MaterialDesc + "%";
      } else if (
        this.defaultValues.DDMaterialDesc == 2 &&
        this.defaultValues.MaterialDesc != ""
      ) {
        this.defaultValues.MaterialDescAPI =
          "%" + this.defaultValues.MaterialDesc;
      } else if (
        this.defaultValues.DDMaterialDesc == 3 &&
        this.defaultValues.MaterialDesc != ""
      ) {
        this.defaultValues.MaterialDescAPI = this.defaultValues.MaterialDesc;
      } else {
        this.defaultValues.MaterialDescAPI = "%";
      }

      if (
        this.defaultValues.DDComment == 1 &&
        this.defaultValues.Comment != ""
      ) {
        this.defaultValues.CommentAPI = "%" + this.defaultValues.Comment + "%";
      } else if (
        this.defaultValues.DDComment == 2 &&
        this.defaultValues.Comment != ""
      ) {
        this.defaultValues.CommentAPI = "%" + this.defaultValues.Comment;
      } else if (
        this.defaultValues.DDComment == 3 &&
        this.defaultValues.Comment != ""
      ) {
        this.defaultValues.CommentAPI = this.defaultValues.Comment;
      } else {
        this.defaultValues.CommentAPI = "%";
      }
      this.HideAppEle = false;
      this.Show = true;
    },
    FillUnitDropDown(value) {
      let that = this;
      const UnitLink =
        this.settings.WAUnit +
        "UserID=" +
        this.limsds_userDetails.userEmail +
        "&site=" +
        this.list.site1 +
        "&lims_internal=" +
        this.defaultValues.lims_internal +
        "&onlySamplesPreviousYear=" +
        this.defaultValues.onlySamplesPreviousYear;
      axios.get(UnitLink).then((response) => {
        that.defaultValues.UnitList = response.data.unitLists;
      });
    },
    FillAreaDropDown(value) {
      let that = this;
      const AreaLink =
        this.settings.WAArea +
        "site=" +
        this.list.site1 +
        "&unit=" +
        this.defaultValues.SelectedUnit +
        "&onlySamplesPreviousYear=" +
        this.defaultValues.onlySamplesPreviousYear;
      axios.get(AreaLink).then((response) => {
        that.defaultValues.AreaList = response.data.areaListV2s;
        that.FillSamplePointDropDown(
          that.list.site1,
          that.defaultValues.SelectedUnit,
          null,
          that.limsds_userDetails.userEmail
        );
      });
    },
    FillSamplePointDropDown(site, unit, area, userid) {
      this.site = this.list.site1;
      if (this.unit != null) {
        this.unit = this.defaultValues.SelectedUnit;
      } else this.unit = "";
      if (this.area != null || area == undefined) {
        this.area = this.defaultValues.SelectedArea;
      } else this.area = "";
      this.userid = this.limsds_userDetails.userEmail;

      const SampleListLink =
        this.settings.WASampleList +
        "site=" +
        this.site +
        "&unit=" +
        this.unit +
        "&area=" +
        this.area +
        "&pointmask=%&descmask=%&userid=" +
        this.userid +
        "&lims_internal=0&earliest_date=01/01/2000";
      axios.get(SampleListLink).then((response) => {
        this.defaultValues.SamplePointList = response.data.sampleLists;
      });

      const ProductLink =
        this.settings.WAProduct +
        "site=" +
        this.site +
        "&unit=" +
        this.unit +
        "&area=" +
        this.area +
        "&onlySamplesPreviousYear=" +
        this.defaultValues.onlySamplesPreviousYear;
      axios.get(ProductLink).then((response) => {
        this.defaultValues.ProductList = response.data.productLists;
      });

      const GroupLink =
        this.settings.WAGroup +
        "site=" +
        this.site +
        "&unit=" +
        this.unit +
        "&area=" +
        this.area +
        "&onlySamplesPreviousYear=" +
        this.defaultValues.onlySamplesPreviousYear;

      axios.get(GroupLink).then((response) => {
        this.defaultValues.LabAreaList = response.data.groups;
      });
    },
  },
};
</script>
<style lang="scss">
.v-text-field.v-text-field--solo.v-input--dense > .v-input__control, .v-text-field--filled.v-input--dense.v-text-field--single-line > .v-input__control > .v-input__slot {
    min-height: 24px;
}
.v-text-field--filled.v-input--dense.v-text-field--single-line .v-label, .v-text-field--full-width.v-input--dense.v-text-field--single-line .v-label {
    top: 3px;
}
.v-text-field__slot {
    padding: 0px !important;
}
.v-btn:not(.v-btn--round).v-size--default {
    height: 26px;
    min-width: 64px;
    padding: 0 10px;
}
</style>

